module.exports = __webpack_public_path__ + "static/img/orderlist_data_none@3x.0624525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orderlist_data_none@3x.png
// module id = 93I7
// module chunks = 1